// Client-side (unverified) read of a JWT's payload. Only used to decide UI/flow
// behaviour — the API verifies the token itself on exchange.
export function decodeJwtPayload(token: string | null | undefined): Record<string, any> | null {
  if (!token) return null
  try {
    const part = token.split('.')[1]
    if (!part) return null
    const base64 = part.replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4)
    return JSON.parse(atob(padded))
  } catch {
    return null
  }
}

// True when the token was minted for a support/impersonation session (support
// login from node-api, "Login as admin" from the stats portal). Such a token is
// authoritative: it must be exchanged even when this origin already holds a
// session, otherwise the operator lands on the old session and the support
// banner never appears.
export function isSupportSessionToken(token: string | null | undefined): boolean {
  return Boolean(decodeJwtPayload(token)?.support_user_id)
}
